import { c as _c } from "react/compiler-runtime";
import { CheckIcon } from '@material-bank/mtag-icons';
type SelectedTileOverlayProps = {
  selected: boolean;
  // The tile's corner radius so the inset ring hugs it (e.g. "rounded-[24px]").
  radiusClassName?: string;
};

// The "in your cart" selected state for a product tile: a white inset ring plus
// a primary check badge in the bottom-right corner. Ported from Studio's
// selectable-product-tile so the interaction matches across MTAG surfaces.
export function SelectedTileOverlay(t0) {
  const $ = _c(5);
  const {
    selected,
    radiusClassName: t1
  } = t0;
  const radiusClassName = t1 === undefined ? "rounded-[24px]" : t1;
  if (!selected) {
    return null;
  }
  const t2 = `pointer-events-none absolute inset-0 ${radiusClassName} ring-[6px] ring-white/80 ring-inset`;
  let t3;
  if ($[0] !== t2) {
    t3 = <div className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="pointer-events-none absolute right-3 bottom-3 flex size-5 items-center justify-center rounded-full bg-primary text-white shadow-sm"><CheckIcon size={12} strokeWidth={2.5} /></div>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}